var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_1010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 10.6666C9.4728 10.6666 10.6667 9.47274 10.6667 7.99998C10.6667 6.52722 9.4728 5.33331 8.00004 5.33331C6.52728 5.33331 5.33337 6.52722 5.33337 7.99998C5.33337 9.47274 6.52728 10.6666 8.00004 10.6666Z",
    stroke: "#CFD3D4",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 5.33333V8.66666C10.6667 9.19709 10.8774 9.7058 11.2525 10.0809C11.6276 10.4559 12.1363 10.6667 12.6667 10.6667C13.1971 10.6667 13.7059 10.4559 14.0809 10.0809C14.456 9.7058 14.6667 9.19709 14.6667 8.66666V7.99999C14.6666 6.49535 14.1575 5.03498 13.2222 3.85635C12.2869 2.67772 10.9804 1.85014 9.51514 1.50819C8.04987 1.16624 6.512 1.33002 5.15161 1.9729C3.79122 2.61579 2.68831 3.69996 2.02222 5.04914C1.35613 6.39832 1.16602 7.93315 1.48283 9.40407C1.79963 10.875 2.6047 12.1955 3.76713 13.1508C4.92957 14.1062 6.381 14.6402 7.88543 14.6661C9.38985 14.692 10.8588 14.2082 12.0534 13.2933",
    stroke: "#CFD3D4",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_1010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.82368c8b019ff91d9ad1e1b3f4b866dd.svg";
export { ForwardRef as ReactComponent };